<template>
    <section class="section">
        <div class="container is-max-widescreen is-max-desktop">
            <h1 class="title has-text-centered">
                Tableau financier
            </h1>

            <b-field grouped>

                <b-field label="Filtre rapide sur les projets">
                    <b-input type="text"
                             v-model="filterP"
                             @input="searchP()">
                    </b-input>
                </b-field>
                <b-field label="Filtre rapide sur les responsables">
                    <b-input type="text"
                             v-model="filterR"
                             @input="searchR()">
                    </b-input>
                </b-field>
                <b-field label="Dossier">
                    <b-select
                        placeholder="Dossiers"
                        @input="filterByFolder">
                        <option value="all">Tout</option>
                        <option
                            v-for="dossier in folders"
                            :value="dossier"
                            :key="dossier">
                            {{ dossier }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Arrondir">
                    <b-switch v-model="isRounded">
                        Arrondir les valeurs
                    </b-switch>
                </b-field>

                <b-field label="Légende colorimétrique">

                    <b-taglist>
                        <b-tag type="is-danger">Budget manquant</b-tag>
                        <b-tag type="is-success">A l'équilibre</b-tag>
                        <b-tag type="is-info">Budget excédentaire</b-tag>
                    </b-taglist>

                </b-field>

                <b-field label="Coût total du filtre">
                    <p>{{ filterSum() }} €</p>
                </b-field>

            </b-field>

            <hr>

            <!-- Boites
            <div class="columns">

                <div class="column">
                </div>

                <div class="column">
                </div>

                <div class="column">
                </div>

                <div class="column">
                </div>
            </div>
            <hr>
            -->
            <hr>


            <b-field grouped
                     group-multiline
                     label="Cocher les colonnes à afficher">
                <div v-for="(column, index) in columnsVisible"
                     :key="index"
                     class="control">
                    <b-checkbox v-model="column.display">
                        {{ column.title }}
                    </b-checkbox>
                </div>
            </b-field>

            <hr>

            <b-table
                :data="data"
                ref="table"
                paginated
                per-page="15"
                detailed
                hoverable
                striped
                custom-detail-row
                detail-key="project"
                show-detail-icon>

                <b-table-column
                    field="name"
                    label="Projets et phases"
                    sortable
                    v-slot="props">
                    <span class="pointer"
                          @click.prevent="getDetailProject(props.row.project)">
                        <b>{{ props.row.project }}</b>
                    </span>
                </b-table-column>

                <b-table-column
                    field="user"
                    label="Responsable">
                    -
                </b-table-column>

                <b-table-column
                    field="intituleprojet"
                    :visible="columnsVisible['intituleprojet'].display"
                    :label="columnsVisible['intituleprojet'].title"
                    sortable
                    v-slot="props">
                    <b>{{ props.row.ProjectLabel }}</b>
                </b-table-column>

                <b-table-column
                    field="typeprojet"
                    :visible="columnsVisible['typeprojet'].display"
                    :label="columnsVisible['typeprojet'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{ props.row.ProjectType }}</b>
                </b-table-column>

                <b-table-column
                    field="dispositif"
                    :visible="columnsVisible['dispositif'].display"
                    :label="columnsVisible['dispositif'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{ props.row.ProjectDispositif }}</b>
                </b-table-column>

                <b-table-column
                    field="fraisdepersonnel"
                    :visible="columnsVisible['fraisdepersonnel'].display"
                    :label="columnsVisible['fraisdepersonnel'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{ isRounded ? roundTwoDigits(props.row.ProjectSalarieCost, 2) : props.row.ProjectSalarieCost }}
                        €</b>
                </b-table-column>

                <b-table-column
                    field="fraisdemission"
                    :visible="columnsVisible['fraisdemission'].display"
                    :label="columnsVisible['fraisdemission'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{ isRounded ? roundTwoDigits(props.row.ProjectFraisCost, 2) : props.row.ProjectFraisCost }}
                        €</b>
                </b-table-column>

                <b-table-column
                    field="achatmat"
                    :visible="columnsVisible['achatdemateriel'].display"
                    :label="columnsVisible['achatdemateriel'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{
                            isRounded ? roundTwoDigits(props.row.ProjectMaterielCost, 2) : props.row.ProjectMaterielCost
                        }} €</b>
                </b-table-column>

                <b-table-column
                    field="sst"
                    :visible="columnsVisible['soustraitance'].display"
                    :label="columnsVisible['soustraitance'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{ isRounded ? roundTwoDigits(props.row.ProjectSSTCost, 2) : props.row.ProjectSSTCost }} €</b>
                </b-table-column>

                <b-table-column
                    field="fraisgeneraux"
                    :visible="columnsVisible['fraisgeneraux'].display"
                    :label="columnsVisible['fraisgeneraux'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{
                            isRounded ? roundTwoDigits(props.row.ProjectFraisGeneraux, 2) : props.row.ProjectFraisGeneraux
                        }} €</b>
                </b-table-column>

                <b-table-column
                    field="couttotal"
                    :visible="columnsVisible['couttotal'].display"
                    :label="columnsVisible['couttotal'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{ isRounded ? roundTwoDigits(props.row.ProjectCost, 2) : props.row.ProjectCost }} €</b>
                </b-table-column>

                <b-table-column
                    field="montantfinanceurs"
                    :visible="columnsVisible['montantfinanceurs'].display"
                    :label="columnsVisible['montantfinanceurs'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{ isRounded ? roundTwoDigits(props.row.ProjectFICost, 2) : props.row.ProjectFICost }} €</b>
                </b-table-column>

                <b-table-column
                    field="resteafinancer"
                    :visible="columnsVisible['resteafinancer'].display"
                    :label="columnsVisible['resteafinancer'].title"
                    sortable
                    centered
                    v-slot="props">
                    <span :class="
                                        [
                                            'tag',
                                            {'is-info': props.row.ProjectCost - props.row.ProjectFICost < 0},
                                            {'is-success': props.row.ProjectCost - props.row.ProjectFICost === 0},
                                            {'is-danger': props.row.ProjectCost - props.row.ProjectFICost > 0},
                                        ]
                                        ">
                                    <b>{{
                                            isRounded ? Math.abs(roundTwoDigits(props.row.ProjectCost - props.row.ProjectFICost, 2)) : Math.abs(props.row.ProjectCost - props.row.ProjectFICost)
                                        }} €</b>
                            </span>
                </b-table-column>

                <b-table-column
                    field="marge"
                    :visible="columnsVisible['marge'].display"
                    :label="columnsVisible['marge'].title"
                    sortable
                    centered
                    v-slot="props">
                    <b>{{
                            isRounded ? roundTwoDigits(props.row.ProjectSalarieMarge, 2) : props.row.ProjectSalarieMarge
                        }} €</b>
                </b-table-column>


                <template slot="detail" slot-scope="props">
                    <tr v-for="item in props.row.synth" :key="item.id">
                        <td>
                            <b-button
                                type="is-primary"
                                icon-right="file"
                                size="is-small"
                                @click.prevent="generatePDF(item.ProjectID, item.ProjectID, 'pdf')">
                            </b-button>
                        </td>
                        <td class="has-text-right">
                            {{ item.ProjectPhase }}
                        </td>

                        <td>
                            {{ item.user }}
                        </td>

                        <td v-show="columnsVisible['intituleprojet'].display" class="has-text-centered">
                        </td>

                        <td v-show="columnsVisible['typeprojet'].display" class="has-text-centered">
                        </td>

                        <td v-show="columnsVisible['dispositif'].display" class="has-text-centered">
                        </td>

                        <td v-show="columnsVisible['fraisdepersonnel'].display" class="has-text-centered">
                            {{ isRounded ? roundTwoDigits(item.ProjectSalarieCost, 2) : item.ProjectSalarieCost }} €
                        </td>
                        <td v-show="columnsVisible['fraisdemission'].display" class="has-text-centered">
                            {{ isRounded ? roundTwoDigits(item.ProjectFraisCost, 2) : item.ProjectFraisCost }} €
                        </td>
                        <td v-show="columnsVisible['achatdemateriel'].display" class="has-text-centered">
                            {{ isRounded ? roundTwoDigits(item.ProjectMaterielCost, 2) : item.ProjectMaterielCost }} €
                        </td>
                        <td v-show="columnsVisible['soustraitance'].display" class="has-text-centered">
                            {{ isRounded ? roundTwoDigits(item.ProjectSSTCost, 2) : item.ProjectSSTCost }} €
                        </td>
                        <td v-show="columnsVisible['fraisgeneraux'].display" class="has-text-centered">
                            {{ isRounded ? roundTwoDigits(item.ProjectFraisGeneraux, 2) : item.ProjectFraisGeneraux }} €
                        </td>
                        <td v-show="columnsVisible['couttotal'].display" class="has-text-centered">
                            {{ isRounded ? roundTwoDigits(item.ProjectCost, 2) : item.ProjectCost }} €
                        </td>
                        <td v-show="columnsVisible['montantfinanceurs'].display" class="has-text-centered">
                            {{ isRounded ? roundTwoDigits(item.ProjectFICost, 2) : item.ProjectFICost }} €
                        </td>

                        <td v-show="columnsVisible['resteafinancer'].display" class="has-text-centered">

                            <span :class="
                                        [
                                            'tag',
                                            {'is-info': item.ProjectCost - item.ProjectFICost < 0},
                                            {'is-success': item.ProjectCost - item.ProjectFICost === 0},
                                            {'is-danger': item.ProjectCost - item.ProjectFICost > 0},
                                        ]
                                        ">
                                    <b>{{
                                            isRounded ? Math.abs(roundTwoDigits(item.ProjectCost - item.ProjectFICost, 2)) : Math.abs(item.ProjectCost - item.ProjectFICost)
                                        }} € </b>
                            </span>

                        </td>
                        <td v-show="columnsVisible['marge'].display" class="has-text-centered">
                            {{ isRounded ? roundTwoDigits(item.ProjectSalarieMarge, 2) : item.ProjectSalarieMarge }} €
                        </td>
                    </tr>

                </template>

            </b-table>

        </div>

        <b-modal :active.sync="isProjectModalActive"
                 has-modal-card
                 full-screen>
            <DetailProject
                :detailProject="detailProject">
            </DetailProject>
        </b-modal>

    </section>
</template>

<script>

import DetailProject from "./DetailProject";

export default {
    name: "TableFinance",
    components: {DetailProject},
    mounted() {
        this.getFolders();
        this.getSynth();
    },
    computed: {},
    methods: {
        generatePDF(id, nom, type) {
            this.$axios.get(`pdf?id=${id}&type=${type}`,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Accept': 'application/pdf'
                    }
                })
                .then(function (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${nom}.pdf`); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                }.bind(this))
                .catch(error => console.log(error));
        },
        getDetailProject(p) {
            this.$axios.get(`project-finance?project=${p}`)
                .then(function (response) {
                    this.detailProject = response.data[0];
                    this.isProjectModalActive = true;
                }.bind(this))
                .catch(error => console.log(error));
        },
        searchP() {
            this.filterR = '';
            this.data = this.dataOrigin;
            if (this.filterP.length > 1) {
                const reg = new RegExp(`${this.filterP}`, 'i');
                this.data = this.dataOrigin.filter(i => i.project.match(reg));
            } else {
                this.data = this.dataOrigin;
            }
        },
        filterByFolder(e) {
            if (e === 'all') {
                this.data = JSON.parse(JSON.stringify(this.dataOrigin));
            } else {
                this.data = [];
                let t = JSON.parse(JSON.stringify(this.dataOrigin));
                console.log(t)
                t.forEach(p => {
                    let arr = p.synth.filter(d => d.dossiers !== null ? d.dossiers.includes(e) : null);
                    let tempP = p;
                    tempP.synth = arr;
                    this.data.push(tempP)
                })
                this.data = this.data.filter(i => i.synth.length > 0);
            }
        },
        searchR() {
            // TODO : refaire ce truc de gitan
            this.filterP = '';
            if (this.filterR.length > 4) {
                this.data = [];
                let t = this.dataOrigin;
                const reg = new RegExp(`${this.filterR}`, 'i');
                t.forEach(p => {
                    let arr = p.synth.filter(d => d.user.match(reg));
                    let tempP = p;
                    tempP.synth = arr;
                    this.data.push(tempP)
                })
                this.data = this.data.filter(i => i.synth.length > 0);
            } else if (this.filterR.length === 0) {
                this.getSynth();
            }
        },
        getSynth() {
            const loadingComponent = this.$buefy.loading.open({
                container: null
            })
            this.$axios.get(`table-finance`)
                .then(function (response) {
                    this.data = response.data;
                    this.dataOrigin = response.data;
                    loadingComponent.close()
                }.bind(this))
                .catch(error => {
                    console.log(error);
                    loadingComponent.close();
                });
        },
        getFolders() {
            this.$axios.get(`ref/folders`)
                .then(function (response) {
                    this.folders = response.data.body.dossiers
                    console.log(this.folders)
                }.bind(this))
                .catch(error => {
                    console.log(error);
                });
        },
        filterSum() {
            let sum = 0;
            console.log(this.data)
            this.data.forEach(d => {
                d.synth.forEach(s => {
                    sum += s.ProjectCost
                })
            })
            return this.roundTwoDigits(sum, 2);
        }
    },
    data() {
        return {
            folders: [],
            data: [],
            dataOrigin: [],
            columnsVisible: {
                intituleprojet: {title: 'Intitulé du projet', display: true},
                typeprojet: {title: 'Type Projet', display: true},
                dispositif: {title: 'Dispositif', display: true},
                fraisdepersonnel: {title: 'Frais de personnel', display: true},
                fraisdemission: {title: 'Frais de missions', display: true},
                achatdemateriel: {title: 'Achat de matériel', display: true},
                soustraitance: {title: 'Sous-traitance', display: true},
                fraisgeneraux: {title: 'Frais généraux', display: true},
                couttotal: {title: 'Coût total', display: true},
                montantfinanceurs: {title: 'Prise en charge Financeurs (€)', display: true},
                resteafinancer: {title: 'Reste à financer (€)', display: true},
                marge: {title: 'Marge (€)', display: true},
            },
            showDetailIcon: true,
            filterP: '',
            filterR: '',
            isRounded: true,
            isProjectModalActive: false,
            detailProject: [],
        }
    }
}
</script>

<style scoped>

.container {
    max-width: 100%;
    padding-left: 5%;
    padding-right: 5%;
}

.pointer {
    cursor: pointer;
}

</style>
